
import axios from "axios";
import moment from 'moment'
import { LIMITE_REGISTROS_PESQUISA } from '../../../static/parametros/parametros.js'

export default {
  namespaced: true,
  state: {
      lista: [],
      dt1: moment().format('YYYY-MM-DD'),
      dt2: moment().format('YYYY-MM-DD'),
      tipoData: 'C',
      responsavelId : null,
      tipoBeneficiamentoId: null,
      tipoSituacao: '0-1-2-3-4', // Default situations to show
      registroPosicao : null,
      registroId : null,
      registroSelecionadoId: null,
  },
  getters: {
    LISTA: state => {
        return state.lista
    },
    DT1: state => {
        return state.dt1
    },
    DT2: state => {
        return state.dt2
    },
    TIPO_DATA: state => {
        return state.tipoData
    },
    RESPONSAVEL_ID: state => {
        return state.responsavelId
    },
    TIPO_BENEFICIAMENTO_ID: state => {
        return state.tipoBeneficiamentoId
    },
    TIPO_SITUACAO: state => {
        return state.tipoSituacao
    },
    REGISTRO_POSICAO: state => {
      for (let i = 0; i < state.lista.length; i++) {
        if (state.lista[i].ID == state.registroId) {
          state.registroPosicao = i
          return state.registroPosicao
        }
      }
      return state.registroPosicao
    },
    REGISTRO_ID: state => {
      return state.registroId
    },
    REGISTRO_SELECIONADO_ID: state => {
        return state.registroSelecionadoId
    }
  },
  mutations: {
      SET_LISTA: (state, payload) => {
          state.lista = payload
      },
      SET_DT1: (state, payload) => {
          state.dt1 = payload
      },
      SET_DT2: (state, payload) => {
          state.dt2 = payload
      },
      SET_TIPO_DATA: (state, payload) => {
          state.tipoData = payload
      },
      SET_RESPONSAVEL_ID: (state, payload) => {
        state.responsavelId = payload
      },
      SET_TIPO_BENEFICIAMENTO_ID: (state, payload) => {
        state.tipoBeneficiamentoId = payload
      },
      SET_TIPO_SITUACAO: (state, payload) => {
        state.tipoSituacao = payload
      },
      SET_LIMPAR: (state, payload) => {
        state.lista = []
        state.dt1 = moment().format('YYYY-MM-DD')
        state.dt2 = moment().format('YYYY-MM-DD')
        state.tipoData = 'C'
        state.responsavelId = null
        state.tipoBeneficiamentoId = null
        state.tipoSituacao = '1-2-3'
        state.registroPosicao = null
      },
      SET_REGISTRO_POSICAO: (state, payload) => {
        state.registroPosicao = payload
      },
      SET_REGISTRO_ID: (state, payload) => {
        state.registroId = payload
      },
      SET_REGISTRO_SELECIONADO_ID: (state, payload) => {
          state.registroSelecionadoId = payload
      }
  },
  actions: {
    GERAR_LISTA: async ({ commit, getters}, { skipConfirmation = false } = {}) => {
      let dt1 = (getters.DT1 !== null ? getters.DT1 : '')
      let dt2 = (getters.DT2 !== null ? getters.DT2 : '')
      let tipoData = getters.TIPO_DATA
      let responsavelId = getters.RESPONSAVEL_ID
      let tipoBeneficiamentoId = getters.TIPO_BENEFICIAMENTO_ID
      let tipoSituacao = getters.TIPO_SITUACAO

      let uri = `/api/protected/producao/pedido/pesquisar?dt1=${dt1}&dt2=${dt2}&tipoData=${tipoData}`
      
      if (responsavelId) {
        uri += `&responsavelId=${responsavelId}`
      }
      if (tipoBeneficiamentoId) {
        uri += `&tipoBeneficiamentoId=${tipoBeneficiamentoId}`
      }
      if (tipoSituacao) {
        uri += `&tipoSituacao=${tipoSituacao}`
      }
      
      const { data, status } = await axios.get(uri)
      
      if (!skipConfirmation && data && data.length > LIMITE_REGISTROS_PESQUISA) {
        return { 
          data, 
          status,
          needsConfirmation: true,
          count: data.length
        }
      }
      
      commit("SET_LISTA", data)
      
      return { data, status, needsConfirmation: false }
    },
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modulos/pedido-producao-store.js